<template>
  <main id="home" class="site-main">
    <div class="grid-container">
      <div class="grid-x grid-padding-x">
        <div class="cell shrink">
          <div class="sidebar">
            <div class="panel text-center">
              <h2>Last Generated SKU</h2>

              <div class="generated-sku"></div>
            </div>

            <div class="panel panel--small panel--black">
              <div class="panel__header">
                <h3 class="panel__title">Settings</h3>
              </div>

              <div class="panel__content">
                <form id="settings-form" class="settings-form" action=""
                      method="post"
                      enctype="multipart/form-data">

                  <div class="form-field">
                    <label for="attribute-seperator">Attribute Seperator</label><br>

                    <div class="select-field">
                      <select id="attribute-seperator" name="attribute-seperator">

                      </select>

                      <i class="fas fa-sort"></i>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div class="cell auto">
          <div class="panel text-center">
            <h2>Your SKU Attributes</h2>

            <table id="sortable-table" class="table-list table-list--no-hover text-left">
              <thead>
              <tr>
                <th style="width: 1px;"></th>
                <th>Type</th>
                <th style="width: 1px;">Length</th>
                <th></th>
              </tr>
              </thead>

              <tbody class="sortable-body" style="width: 100%; position: relative;">

              </tbody>
            </table>

            <div class="form-field" style="padding-top: 20px;">
              <label>Add New Attribute to SKU</label><br>

              <form action="" method="post" enctype="multipart/form-data">
                <div class="grid-x grid-padding-x align-bottom text-left">
                  <div class="cell auto">
                    <div class="form-field">
                      <label for="attribute-type">Type</label><br>

                      <div class="select-field">
                        <select id="attribute-type" name="attribute-type">

                        </select>

                        <i class="fas fa-sort"></i>
                      </div>
                    </div>
                  </div>

                  <div class="cell small-2">
                    <div class="form-field">
                      <label for="attribute-length">Length</label><br>

                      <input id="attribute-length" class="short-input" name="attribute-length"
                             type="text">
                    </div>
                  </div>

                  <div class="cell shrink">
                    <button>Add</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'home',
  components: {},
  created () {

  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/mixins';

</style>



// WEBPACK FOOTER //
// src/apps/autosku/home.vue